import { createFileRoute } from '@tanstack/react-router';
import { JourneysIntegrationsHandoff } from '@/pages/workspaces/journeys/integrations/routing';

function JourneysIntegrationsDirectoryRoute() {
  return <JourneysIntegrationsHandoff target="directory" />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/all/directory')({
  component: JourneysIntegrationsDirectoryRoute,
});
